export default "__VITE_ASSET__Bq6joMdw__"